import { DischargeType, dischargeTypeMessages } from "@/utils/enums/sintegrada/discharge/DischargeType";

import { SelectComponent, SelectComponentProps } from "@/components/SelectComponent";

type Props = SelectComponentProps;

export const defaultDischargeTypeSelectOption = {
	label: "Todas",
	value: null,
};

export function DischargeTypeSelect({
    ...props
}: Props) {
    const dischargeTypes = [
        DischargeType.ImprovedDischarge,
        DischargeType.HealedDischarge,
        DischargeType.Evasion,
        DischargeType.DischargeOnAbandonment,
        DischargeType.DischargeOnDeath,
        DischargeType.AdministrativeDischarge,
        DischargeType.DischargeByTransfer,
        DischargeType.DischargeOnMedicalAdvice,
        DischargeType.DischargeOnRequest,
    ];

    const dischargeTypeOptions = dischargeTypes.map(dischargeType => ({
        label: dischargeTypeMessages[dischargeType],
        value: dischargeType,
    }));

    const options = [
        defaultDischargeTypeSelectOption,
        ...dischargeTypeOptions,
    ];

    return (
        <SelectComponent
            placeholder="Selecione..."
            options={options}
            {...props}
        />
	);
}
